const resources = {
  en: {
    common: {
      checkout: {
        details: 'Details',
        subtotal: 'Subtotal',
        tax: 'Tax',
        total: 'Total',
        poweredBy: 'Powered by',
        privacyPolicy: 'Privacy Policy',
        refundPolicy: 'Refund Policy',
        somethingWentWrong: 'Something went wrong',
        unableToOpenCheckout: 'Unable to Open Checkout',
        pleaseTryAgainInAMoment: 'Please try again in a moment.',
        unableToCompleteOrder: "We couldn't complete your order.\nPlease contact support for assistance",
        unableToProcessPayment: 'Unable to Process Payment',
        pleaseReopenTheCheckoutAndTryAgain: 'Please reopen the checkout and try again.',
        returnToGame: 'Return to Game',
        returnToStore: 'Return to Store',
        pay: 'Pay',
        apply: 'Apply',
        promoCode: 'Promo code',
        discount: 'Discount',
        payButtonDisclaimerPrefix:
          'By clicking "Pay" you indicate that you have read, understood and agree to Appcharge\'s',
        endUserLicenseAgreement: 'EULA',
        and: 'and',
        cardholderName: 'Cardholder name',
        emailAddress: 'Email Address',
        address: 'Address',
        cardNumber: 'Card number',
        expiration: 'Expiration',
        zip: 'ZIP Code',
        postalCode: 'Postal Code',
        city: 'City',
        remove: 'Remove',
        creditCard: 'Card',
        cvc: 'CVC',
        backToGame: 'Back to Game',
        newCard: 'Add New Card',
        changeOrAddCard: 'Change or Add Card',
        savedCards: 'Saved Cards',
        delete: 'Delete',
        select: 'Select',
        cancel: 'Cancel',
        saveCardCheckbox: 'Save my card details for future purchases',
        morePaymentMethodsAvailable: 'More payment methods available',
        selectAnOption: 'Select an option',
        payWithDebitOrCreditCard: 'Pay with Debit or Credit Card',
        paymentMethodNotAvailable:
          "This payment method isn't available right now. Please go back and try selecting a different method.",
        purchaseCompleted: 'Purchase Completed!',
        orderId: 'Order ID: {{id}}',
        wellBeRightBack: "We'll Be Right Back",
        checkoutUnavailable: 'Checkout is temporarily unavailable.',
        support: 'Support',
        contactSupport: 'Contact Support',
        allPaymentsSecureAndEncrypted: 'All payments are secure and encrypted.',
        paymentViaGooglePay: 'Payment via Google Pay',
        googlePayRedirectMessage: 'You will be redirected to Google Pay to complete the payment.',
        paymentViaPaypal: 'Payment via PayPal',
        paypalRedirectMessage: 'You will be redirected to PayPal to complete the payment.',
        processing: 'Processing',
        pleaseCompletePaymentInWindow: 'Please complete payment in the opened window',
        backToStore: 'Back to Store',
        dataSecurity: 'Data Security',
        failedToRemovePromoCode: 'Failed to remove promo code. Please try again',
        couponDoesNotExist: 'Promo code is invalid. Check the spelling and try again.',
        maxCardsReached: "You've reached the maximum of {{max}} saved cards. Remove a card to add a new one.",
        provideValidZipCode: 'Please provide a valid ZIP code to proceed with the payment',
        provideValidPostalCode: 'Please provide a valid postal code to proceed with the payment',
        back: 'Back',
        paymentMethodBrowserNotSupported: "This payment method isn't supported in your current browser.",

        fieldErrors: {
          incomplete: 'Your {{field}} is incomplete.',
          incomplete_cvc: 'Incomplete cvc',
          incomplete_date: 'Incomplete date',
          date_in_past: 'Date in past',
          invalid_expiration_year: 'Invalid expiration year',
          incomplete_card_number: 'Incomplete card number',
          incorrect_card_number: 'Incorrect card number',
          incompleteEmail: 'Your email address is incomplete.',
          invalidEmail: 'Your email address is invalid.',
          incompleteCardholderName: 'Cardholder name is incomplete.',
          missingZipCode: 'Missing ZIP code.',
          invalidZipCode: 'Invalid ZIP code.',
          missingPostalCode: 'Missing Postal Code.',
          invalidPostalCode: 'Invalid Postal Code.',
          invalidCard: 'Your card number is invalid.',
          incompleteCard: 'Your card number is incomplete.',
          incompleteExpirationDate: "Your card's expiration date is incomplete.",
          invalidExpirationDate: "Your card's expiration year is invalid.",
          incompleteSecurityCode: "Your card's security code is incomplete.",
          invalidSecurityCode: "Your card's security code is invalid.",
          invalidFormat: 'Invalid format for {{field}}',
          twoWordsRequired: '{{field}} must contain first and last name',
          shopperName: 'Your name must be two words and contain only letters',
          shopperEmail: 'Your email address is invalid.',
          telephoneNumber: 'Your phone number must contain only numbers',
          invalidAddress: 'Address must be at least 7 characters long.',
        },
        appchargeErrors: {
          generic: 'Payment could not be processed. Please try again or use a different method.',
          incorrectCvc: 'The security code is incorrect. Please try again.',
          timeout: 'The payment request timed out. Please try again.',
          expiredCard: 'Your card has expired. Please use a different card.',
          cardNotSupported: 'Your card is not supported. Please use a different payment method.',
          insufficientFunds: 'Payment could not be processed. Please try again or use a different method.',
          connection: 'There was a connection error. Please check your internet connection and try again.',
          transactionNotPermitted: 'Payment could not be processed. Please use a different method.',
          authorizationError: 'The payment was not authorized. Please try again or use a different method.',
          suspectFraud: 'Payment could not be processed. Please use a different payment method.',
          authenticationRequired: 'Payment could not be processed. Please try again or use a different method.',
          authenticationNotHandled: 'Payment could not be processed. Please try again or use a different method.',
          approveWithId: 'Payment could not be processed. Please use a different method.',
          cardVelocityExceeded: 'Your card is not supported. Please use a different payment method.',
          currencyNotSupported:
            'This card doesn’t support the selected currency. Please use a different payment method.',
          duplicateTransaction:
            'A similar payment was just made. Check if you were already charged before trying again.',
          genericDecline: 'Payment could not be processed. Please try again or use a different method.',
          incorrectAddress: 'The billing address is incorrect. Update it or use a different method.',
          invalidZip: 'The postal code is incorrect. Please check and try again.',
          invalidAccount: 'Payment could not be processed. Please use a different method.',
          invalidAmount: 'Payment could not be processed. Please use a different method.',
          invalidCvc: 'The security code is incorrect. Please try again.',
          invalidExpiryDate: 'The expiration date is incorrect. Please try again.',
          invalidNumber: 'The card number is incorrect. Please try again.',
          invalidPin: 'The PIN is incorrect. Please try again.',
          notPermitted: 'Payment could not be processed. Please try again or use a different method.',
          pinTryExceeded: 'Payment could not be processed. Please try again using a different method.',
          processingError: 'Payment could not be processed. Please try again or use a different method.',
          revocationOfAuthorization: 'Payment could not be processed. Please use a different method.',
          withdrawalCountLimitExceeded: 'Payment could not be processed. Please try again or use a different method.',
        },
      },
    },
  },
};

export default resources;
